__turbopack_context__.v({
  "caption": "cart-summary-module-scss-module__gIUgWG__caption",
  "clock": "cart-summary-module-scss-module__gIUgWG__clock",
  "cta": "cart-summary-module-scss-module__gIUgWG__cta",
  "discount": "cart-summary-module-scss-module__gIUgWG__discount",
  "left": "cart-summary-module-scss-module__gIUgWG__left",
  "more": "cart-summary-module-scss-module__gIUgWG__more",
  "parts": "cart-summary-module-scss-module__gIUgWG__parts",
  "preorder": "cart-summary-module-scss-module__gIUgWG__preorder",
  "root": "cart-summary-module-scss-module__gIUgWG__root",
  "ship-title": "cart-summary-module-scss-module__gIUgWG__ship-title",
  "shipping": "cart-summary-module-scss-module__gIUgWG__shipping",
  "sum": "cart-summary-module-scss-module__gIUgWG__sum",
  "sums": "cart-summary-module-scss-module__gIUgWG__sums",
  "title": "cart-summary-module-scss-module__gIUgWG__title",
  "total": "cart-summary-module-scss-module__gIUgWG__total",
  "total-label": "cart-summary-module-scss-module__gIUgWG__total-label",
  "total-value": "cart-summary-module-scss-module__gIUgWG__total-value",
});
